export const LETTERS: Record<string, string> = Object.freeze({
  "en-us": "abcdefghijklmnopqrstuvwxyz",
});

export const SYMBOLS: Record<string, string> = Object.freeze({
  "en-us": "0123456789!?@#$%&",
});
